import module from "./bedbuilder-store";

const OPTION_IMAGES = {
  Material:
    "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/sizeIcon.svg",
  Colour:
    "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/colourIcon.svg",
  Headboard:
    "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/headboardIcon.svg",
  Base: "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/baseIcon.svg",
};

// TODO Fialized the default options
const DEFAULT_OPTIONS = {
  Material: "Timber",
  Colour: "Twilight",
  Headboard: "Curved",
  Base: "4 Drawer E/W",
};
const DEFAULT_OPTION_NAMES = ["Material", "Colour", "Headboard", "Base"];

export default ({ app, store, query }, inject) => {
  app.store.registerModule("bedbuilder", module);

  function processAvailableOptions(options) {
    const lookup = {};
    const headboardDrawers = {};

    const processItems = (items, type) => {
      for (const item of items) {
        const name = item.name;
        const colours = JSON.parse(item.colours[0].text);
        const materials = JSON.parse(item.materials[0].text);

        if (type === "headboard") {
          headboardDrawers[name] = item.drawers;
        }

        for (const material of materials) {
          for (const colour of colours) {
            if (!lookup[material]) lookup[material] = {};
            if (!lookup[material][colour])
              lookup[material][colour] = {
                Base: new Set(),
                Headboard: new Set(),
              };

            if (type === "base") {
              lookup[material][colour].Base.add(name);
            } else {
              lookup[material][colour].Headboard.add(name);
            }
          }
        }
      }
    };

    processItems(options.base, "base");
    processItems(options.headboard, "headboard");

    const optionsColours = new Map();
    for (const option of options.colours) {
      optionsColours.set(option.name, option.colour);
    }

    const baseOptions = DEFAULT_OPTION_NAMES.map(name => {
      return {
        name,
        image: { alt: `${name} Image`, url: OPTION_IMAGES[name] || "" },
      };
    });

    store.dispatch("bedbuilder/init", {
      availableOptions: lookup,
      baseOptions,
      optionsColours,
      headboardDrawers,
    });
  }

  inject("bedbuilder", {
    processAvailableOptions,
    defaultOptions: DEFAULT_OPTIONS,
  });
};
